import {latMeasure, lngMeasure} from './';
import {labelFormat} from '../../modules/util';

function _addr2coord (addr, geocoder, callback) { // 주소 변환에 사용
  geocoder.addr2coord(addr, function (status, result) {
    if (status === daum.maps.services.Status.OK) {
      return callback(null, result.addr[0]);
    } else {
      return callback(status); // 결과 없을 때 처리
    }
  });
}

function _rScaleRange (scale, level, size) {
  let magVal = Math.pow(2, level); //level에 따라 measure 조절
  scale.range([size.range[0] * magVal, size.range[1] * magVal]); // 반지름의 최대 최소 값에 매핑);
}
function _mark() {
  const map = this.__execs__.map;
  const field = this.__execs__.field;
  const scale = this.__execs__.scale;
  const dispatch = this.__execs__.dispatch;
  const isAddr = this.addr();
  const label = this.label();
  const target = this.data();
  const isSized = this.isSized();
  const size = this.size();
  const color = this.color();
  const geocoder = new daum.maps.services.Geocoder();
  const circles = [];
  
  let __set = function() {
    const latlng = target.map(d => new daum.maps.LatLng(d[field.lat.field], d[field.lng.field]));
    const bounds = new daum.maps.LatLngBounds();
    latlng.forEach(function (d) {
      bounds.extend(d);
    });
    map.setBounds(bounds);
    const level = map.getLevel();
    if(isSized) _rScaleRange(scale.r, level, size);
  }
  let __nodes = function() {
    const level = map.getLevel();
    const earthR = 111111; // 툴팁 위치 조정시 사용
    target.forEach(d => {
      const latLng = new daum.maps.LatLng(d[field.lat.field], d[field.lng.field]);
      const radius = isSized ? scale.r(Math.sqrt(d[field.radius.field])) : size.range[0] * Math.pow(2, level);
      const option = {
        clickable: true,
        zIndex: 10,
        center: latLng,  // 원의 중심좌표
        radius: radius, // 미터 단위의 원의 반지름
        strokeColor: color[0],
        strokeWeight: 1.5,
        strokeOpacity: 1,
        strokeStyle: 'solid',
        fillColor :  color[0],
        fillOpacity: 0.5
      };
      const circle = new daum.maps.Circle(option);
      circle.setMap(map);
      circles.push(circle);

      const keyVal = field.name ? d[field.name.field] : isAddr ? d[field.addr.field] : '위도: ' + labelFormat(d[field.lat.field]) + '</br> 경도: ' + labelFormat(d[field.lng.field]);
      const tooltipText = '<div class="daisy-chart-tooltip" style="padding:4px;font-size:12px;font-family:sans-serif;">' +
      '<div class="daisy-chart-key" style="font-weight:bold;">' + keyVal + '</div>' +
      (isSized  ? '<div class="daisy-chart-value">' + field.radius.field + ': ' + labelFormat(d[field.radius.field]) + '</div>' : '') +
      '</div>';
      const tooltip = new daum.maps.InfoWindow({
        position: new daum.maps.LatLng(d[field.lat.field] + radius / earthR, d[field.lng.field]),
        content: tooltipText
      });

      // 버블 마우스 이벤트
      
      daum.maps.event.addListener(circle, 'mouseover', function () {
        tooltip.open(map);
      });
      daum.maps.event.addListener(circle, 'mouseout', function () {
        tooltip.close();
      });
      

      if (isSized && label) {
        const value = labelFormat(d[field.radius.field]);
        const label = new daum.maps.CustomOverlay({
          position: latLng,
          clickable: true,
          zIndex: -1,
          content: '<div class="label" style="pointer-events:none;padding:4px;font-size:12px;font-family:sans-serif;">' + value + '</div>'
        });
        label.setMap(map);
      }
    })
  }

  if(isAddr) {
    let count = 0;
    
    target.forEach(function(d) {
      let addr = d[field.addr.field];
      let callback = function(err, coord) {
        if(!err) {
          d[latMeasure.field] = coord.lat;
          d[lngMeasure.field] = coord.lng;
        }
        count += 1;
        dispatch.call('loading', this, count);
        if(count === target.length) {
          __set();
          __nodes();
          dispatch.call('end');
        }
      }
      try {
        _addr2coord(addr, geocoder, callback)
      } catch (e) {
        callback(e);
      }
    })
  } else {
    __set();
    __nodes();
  }
  if(!isSized) {
    daum.maps.event.addListener(map, 'zoom_changed', function() {
      const radius = size.range[0] * Math.pow(2, map.getLevel());
      circles.forEach(function(circle) {
        circle.setRadius(radius);
      })
    });
  }
}

export default _mark;


// WEBPACK FOOTER //
// ../node_modules/daisy-chart/src/layouts/marker-map/_mark.js